<div class="main" [ngClass]="{'blue-belt': blueBelt !== null && blueBelt === true, 'practitioner': blueBelt !== null && blueBelt === false}">
    <exam-header [linkAction]="'BlueHelp®'" (linkClick)="openHelp()"></exam-header>
    <div class="body">
        <div class="title" qa="logo-text">
            {{blueBelt ? 'Blue Belt Certification Exams' : 'Certified Blueprinting Practitioner Exams'}}
        </div>
    </div>
</div>
